import request from "../util/request";
import SERVER_URL from "../util/seaver";

function deptSel(reqData) {
    const reqUrl =
        SERVER_URL + "/dept/sel";
    return request({
        url: reqUrl,
        method: "POST",
        data: reqData
    });
}

function deptAdd(reqData) {
    const reqUrl =
        SERVER_URL + "/dept/add";
    return request({
        url: reqUrl,
        method: "POST",
        data: reqData
    });
}

function deptDel(reqData) {
    const reqUrl =
        SERVER_URL + "/dept/del";
    return request({
        url: reqUrl,
        method: "POST",
        data: reqData
    });
}

function deptUpdate(reqData) {
    const reqUrl =
        SERVER_URL + "/dept/mod";
    return request({
        url: reqUrl,
        method: "POST",
        data: reqData
    });
}
export { deptSel, deptAdd, deptDel, deptUpdate };
